<unity-page-container
  [contentHeader]="$contentHeader()"
  [contentHeaderSecondary]="$contentHeaderSecondary()"
  [isLoading]="$isAgreementLoading()">
  <ng-container page-return> <unity-action-shared [action]="$returnToAgreementAction()" /></ng-container>
  <ng-container notifications />

  <ng-container actions>
    @let createFormResponse = $createFormResponse();
    @if (!!createFormResponse) {
      <unity-action-shared [action]="createFormResponse" />
    }
  </ng-container>

  @let agreementId = $agreementId();
  @let formSchedule = formScheduleResource.value();

  @if ($useGrid()) {
    @if (formSchedule) {
      <unity-grid-form-response-shared [agreementId]="agreementId" [formSchedule]="formSchedule" />
    }
  } @else {
    <kendo-stacklayout orientation="vertical" [align]="{ vertical: 'top' }" [gap]="5">
      @if ($hasInstances()) {
        @let instancesNeedingChanges = $instancesNeedingChanges();
        @if (instancesNeedingChanges && instancesNeedingChanges.length > 0) {
          <unity-list-form-instance-shared
            headerText="Items Needing Changes"
            formInstanceListType="NeedsChanges"
            [agreementId]="agreementId"
            [formInstances]="instancesNeedingChanges"
            [highlightedRecordId]="$highlightedRecordId()" />
        }
        @let draftinstances = $draftInstances();
        @if (draftinstances && draftinstances.length > 0) {
          <unity-list-form-instance-shared
            headerText="Draft Items"
            formInstanceListType="Draft"
            [agreementId]="agreementId"
            [formInstances]="draftinstances"
            [highlightedRecordId]="$highlightedRecordId()" />
        }
        @let openInstances = $openInstances();
        @if (openInstances && openInstances.length > 0) {
          <unity-list-form-instance-shared
            headerText="Open Items"
            noRecordsText="No open items right now. New items will appear here as they become available."
            formInstanceListType="Open"
            [agreementId]="agreementId"
            [formInstances]="openInstances"
            [highlightedRecordId]="$highlightedRecordId()" />
        }
        @let instancesPendingApproval = $instancesPendingApproval();
        @if (instancesPendingApproval && instancesPendingApproval.length > 0) {
          <unity-list-form-instance-shared
            headerText="Items Awaiting Approval"
            formInstanceListType="PendingApproval"
            [agreementId]="agreementId"
            [formInstances]="instancesPendingApproval"
            [highlightedRecordId]="$highlightedRecordId()" />
        }
        @let instancesPendingDirectorApproval = $instancesPendingDirectorApproval();
        @if (instancesPendingDirectorApproval && instancesPendingDirectorApproval.length > 0) {
          <unity-list-form-instance-shared
            headerText="Items Awaiting Director Approval"
            formInstanceListType="PendingDirectorApproval"
            [agreementId]="agreementId"
            [formInstances]="instancesPendingDirectorApproval"
            [highlightedRecordId]="$highlightedRecordId()" />
        }
        @let rejectedInstances = $rejectedInstances();
        @if (rejectedInstances && rejectedInstances.length > 0) {
          <unity-list-form-instance-shared
            headerText="Rejected Items"
            formInstanceListType="Rejected"
            [agreementId]="agreementId"
            [formInstances]="rejectedInstances"
            [highlightedRecordId]="$highlightedRecordId()" />
        }
        @let completedInstances = $completedInstances();
        @if (completedInstances && completedInstances.length > 0) {
          <unity-list-form-instance-shared
            headerText="Completed Items"
            formInstanceListType="Completed"
            [agreementId]="agreementId"
            [formInstances]="completedInstances"
            [highlightedRecordId]="$highlightedRecordId()" />
        }
      } @else {
        <h4>No forms are currently available for this agreement.</h4>
      }
    </kendo-stacklayout>
  }
</unity-page-container>
